var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finishUpProject-style"},[_c('headerNav',{attrs:{"title":"待上传","leftNav":"返回"},on:{"leftClick":_vm.cancel}}),_c('div',{staticClass:"content-style"},[_c('img',{attrs:{"src":require('@/assets/tobeupdated.png'),"alt":"","width":"50%"}}),_c('p',[_vm._v("待项目经理上传中...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }